var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKafPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kaf"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "206.69 70.94 195.41 58.55 185.62 70.45 164.06 72.43 175.21 61.15 194.92 58.55",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "125.15 25.71 39.04 14.6 52.45 52.19 229.62 60.91 191.94 35.25 138.43 27.7",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.35 28.32 130.35 11.96 129.86 10.22 129.86 7.62 138.53 8.86 138.53 11.21 137.17 12.45 137.17 21.13 138.16 22.37 138.16 29.31 130.35 28.32",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "129.86 7.62 126.39 9.23 125.15 11.46 125.15 12.58 126.02 13.32 126.02 22.24 125.15 23.11 125.15 25.71 130.35 28.32",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "222.8 60.91 222.8 88.17 203.56 90.18",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.62,
    y1: 70.45,
    x2: 206.57,
    y2: 70.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.41 72.68 167.41 94.37 185.5 95.98 203.72 93.75 203.72 70.94",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.5,
    y1: 95.98,
    x2: 185.5,
    y2: 71.07,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "190.09 95.11 190.09 75.9 196.03 75.78 196.03 94.12",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.42 76.65 172.36 77.26 172.36 88.17 180.42 88.17 180.42 76.65",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.58,
    y1: 87.8,
    x2: 176.58,
    y2: 77.02,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.49,
    y1: 80.86,
    x2: 180.17,
    y2: 80.49,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.61,
    y1: 84.82,
    x2: 180.05,
    y2: 84.58,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.62 70.37 138.7 70.86 138.7 87.34 147.62 86.85 147.62 70.37",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.19,
    y1: 76.56,
    x2: 147.37,
    y2: 75.94,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.91,
    y1: 70.74,
    x2: 142.91,
    y2: 87.22,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.95,
    y1: 81.89,
    x2: 147.13,
    y2: 81.15,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.42 71.19 109.07 71.71 109.07 88.96 118.42 88.45 118.42 71.19",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.59,
    y1: 77.68,
    x2: 118.16,
    y2: 77.03,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.49,
    y1: 71.58,
    x2: 113.49,
    y2: 88.83,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.33,
    y1: 83.26,
    x2: 117.9,
    y2: 82.48,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.35 70.45 77.89 71.03 77.89 90.36 88.35 89.78 88.35 70.45",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.47,
    y1: 77.72,
    x2: 88.06,
    y2: 76.99,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.83,
    y1: 70.89,
    x2: 82.83,
    y2: 90.21,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.18,
    y1: 83.96,
    x2: 87.77,
    y2: 83.09,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "52.45 52.19 52.57 102.38 167.38 93.97",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "52.57 102.38 26.38 89.53 26.38 45.96 39.3 14.6",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKafPop);
export default __webpack_public_path__ + "static/media/kaf_pop.a4078acd9de9c682e8c7d59460b9f59f.svg";
export { ForwardRef as ReactComponent };